<template>
  <div class="main-body">
    <div class="header">自分配后台账号</div>
    <div class="out">

      <div class="search2">

        <el-button size="mini" type="primary" plain @click.native="toggleModalAdd">添加</el-button>

        <div style="clear: both;"></div>
      </div>

      <el-table class="table" size="mini" v-loading="tableLoading" :data="tableData" :height="th" border>

        <el-table-column prop="loginName" label="登录名称" width="200" fixed></el-table-column>

        <el-table-column prop="roleName" label="角色"></el-table-column>

        <el-table-column prop="realName" label="姓名"></el-table-column>

        <el-table-column prop="phone" label="手机" width="120"></el-table-column>

        <el-table-column prop="status" :formatter="statusTitle" label="状态"></el-table-column>

        <el-table-column prop="createTime" label="注册日期" width="180">
          <template slot-scope="scope">
            <p>{{scope.row.createTime | timefilters }}</p>
          </template>
        </el-table-column>


        <el-table-column fixed="right" label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text"
                       size="mini" @click="handleEdit(scope.$index, scope.row)">编辑</el-button>
            <el-button type="text"
                       size="mini" @click="handlePassword(scope.$index, scope.row)">修改密码</el-button>
          </template>
        </el-table-column>

      </el-table>

      <div class="page">
        <div style="float: left;">共{{totalItems}}条（{{Math.ceil(totalItems/pageSize)}}页）
        </div>
        <div style="float: left;">
          <el-pagination small
              background
              layout="prev, pager, next"
              :total="totalItems"
              :page-size="20"
              :current-page.sync="currentPage"  @current-change="current_change">
          </el-pagination>
        </div>
        <div style="clear: both;"></div>
      </div>

    </div>

    <el-dialog title="密码修改" :visible.sync="batchDialog" class="dialog" width='400px' center top='30vh'
               :close-on-click-modal='false'>
      <el-input v-model="password" placeholder="请输入登录密码" maxlength="10" minlength="6"
                show-password></el-input>
      <div slot="footer" class="dialog-footer">
        <el-button @click="batchDialog=false">取 消</el-button>
        <el-button type="primary" @click="editPassword">提交</el-button>
      </div>
    </el-dialog>


    <Add ref="myAdd" v-show="showModalAdd" v-on:closeAdd="closeAdd" v-on:getList="getList"></Add>
    <Edit ref="myEdit" v-show="showModalEdit" v-on:closeEdit="closeEdit" v-on:getList="getList"></Edit>


  </div>
</template>

<script>

import Add from "./Add";
import Edit from "./Edit";

import {getStaffCode} from "@/utils/auth";
import {timeStr} from "@/common/times";
import {hex_md5} from "@/common/Base64MD5";

export default {
  name: "Page",

  //注册局部过滤器
  filters: {
    timefilters(val) {
      if (val == null || val == "") {
        return "";
      } else {
        let d = new Date(val);   //val 为表格内取到的后台时间
        let month =
            d.getMonth() + 1 < 10 ? "0" + (d.getMonth() + 1) : d.getMonth() + 1;
        let day = d.getDate() < 10 ? "0" + d.getDate() : d.getDate();
        let hours = d.getHours() < 10 ? "0" + d.getHours() : d.getHours();
        let min = d.getMinutes() < 10 ? "0" + d.getMinutes() : d.getMinutes();
        let sec = d.getSeconds() < 10 ? "0" + d.getSeconds() : d.getSeconds();
        let times = d.getFullYear() + '-' + month + '-' + day + ' ' + hours + ':' + min + ':' + sec;
        return times;
      }
    }
  },

  data() {
    return {

      tableData: [],
      totalItems: 0,
      pageSize: 20,
      currentPage: 1,


      tableLoading: false,

      batchDialog: false,
      workersCode: '',
      password: '',

      options: [{
        value: -1,
        label: '全部状态'
      }, {
        value: 0,
        label: '默认'
      }, {
        value: 1,
        label: '已通过'
      }, {
        value: 2,
        label: '被禁用'
      }],
      status: -1,

      realName:'',
      phone:'',
      zoneCode:'',


      showModalAdd: false,
      showModalEdit: false,

      roleList: null,
      editStaff: null,
      th: 0,
      zoneValue:[],

    }
  },
  created() {
    this.getList();
    this.th = this.$store.state.tableHeight;
  },
  components: {
    Add, Edit
  },
  watch: {
    //监听全局变量
    '$store.state.tableHeight': function (val) {
      this.th = val;
    },
  },
  methods: {
    init(){

    },


    toggleModalAdd: function () {
      this.showModalAdd = !this.showModalAdd;
      this.$refs.myAdd.init();
    },
    closeAdd: function () {
      this.showModalAdd = !this.showModalAdd;
    },


    handleEdit(index, row) {
      this.$refs.myEdit.init(row);
      this.showModalEdit = !this.showModalEdit;
    },
    closeEdit: function () {
      this.showModalEdit = !this.showModalEdit;
    },

    current_change: function (currentPage) {
      this.currentPage = currentPage;
      this.getList();
    },
    getList(isSearch){
      if(isSearch)this.currentPage=1

      this.tableLoading=true
      this.$axios({
        method: 'post',
        url: this.$shopUrl + 'Staff/GovPageAuto',
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          pageIndex: this.currentPage,
          pageSize: this.pageSize,
        }
      }).then((response) => {
        this.tableLoading=false
        if (response.data.error == 0) {
          this.tableData = response.data.data.list;
          this.totalItems = response.data.data.total;
        } else if (response.data.error == 1) {
          this.$message(response.data.message);
        } else {
          console.log(response.data.message);
        }
      }).catch(function (error) {
        //this.tableLoading=false
        console.log(error);
      });
    },



    handlePassword(index, rows) {
      this.batchDialog = true;
      this.workersCode = rows.staffCode
    },
    editPassword() {
      if (this.password.length < 6) {
        this.$message('密码至少为六位')
        return;
      }
      this.$axios({
        method: 'post',
        url: this.$shopUrl + 'Staff/EditPassword',
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          editStaffCode: this.workersCode,
          password: this.password,
        }
      }).then((response) => {
        console.log(response);
        if (response.data.error == 0) {
          this.$message('修改成功');
          this.batchDialog = false
        } else if (response.data.error == 1) {
          this.$message(response.data.message);
        } else {
          console.log(response.data.message);
        }

      }).catch(function (error) {
        console.log(error);
      });
    },




    statusTitle(row) {
      if (row.status === 0) {
        return "默认";
      }
      if (row.status === 1) {
        return "正常";
      }
      if (row.status === 2) {
        return "被禁用";
      }
      return "其它";
    },


  }
}
</script>

<style  lang="scss" scoped>
/*.demonstration{*/
/*    padding: 10px;*/
/*    line-height: 34px;*/
/*    fonts-size: 16px;*/
/*}*/
.userStaff /deep/ .el-form-item{
  margin-bottom: 0;
}

.modal-body {
  position: relative;
  padding: 20px 0px;
  z-index: 99;
  overflow-y:scroll;
  height: 400px;
}
</style>
